import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Select, Table, Tooltip } from "antd";
import { API_BASE_URL } from "../Config/Config";
import Swal from "sweetalert2";
import { CopyOutlined } from "@ant-design/icons";
const GenerateLicence = ({ record }) => {
  console.log(record, "generate");

  const userData = JSON.parse(
    sessionStorage.getItem("HealthCheckuser") || "[]"
  );

  const [locationType, setLocationType] = useState([]);
  const [locationHistoryLoading, setLocationHistoryLoading] = useState(false);
  const [locationHistory, setLocationHistory] = useState([]);
  console.log(locationHistory, locationHistoryLoading);
  const [deviceLoading, setDeviceLoading] = useState(false);
  const [deviceData, setDeviceData] = useState([]);

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [loading, setLoading] = useState(false);
  const[locationLoading,setLocationLoading] = useState(false);


  console.log(selectedDevice);

  const columns = [
    {
      title: "Location",
      dataIndex: "Location",
      key: "Location",
      render: (text) => (
        <Tooltip title={text || "-"}>
          <div className="d-flex align-items-center gap-2">
            <span>
              {text
                ? text.length > 10
                  ? `${text.substring(0, 10)}...`
                  : text
                : "-"}
            </span>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Device",
      dataIndex: "DeviceName",
      key: "DeviceName",
      render: (text) => (
        <Tooltip title={text || "-"}>
          <div className="d-flex align-items-center gap-2">
            <span>
              {text
                ? text.length > 10
                  ? `${text.substring(0, 10)}...`
                  : text
                : "-"}
            </span>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "RenewalDt",
      dataIndex: "RenewalDate",
      key: "RenewalDate",
      render: (text) => (
        <Tooltip title={text || "-"}>
          <div className="d-flex align-items-center gap-2">
            <span>
              {text
                ? text.length > 10
                  ? `${text.substring(0, 10)}...`
                  : text
                : "-"}
            </span>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Key",
      dataIndex: "LicenseKey",
      key: "LicenseKey",
      render: (text) => (
        <Tooltip title={text || "-"}>
          <div className="d-flex align-items-center gap-2">
            <span>
              {text
                ? text.length > 10
                  ? `${text.substring(0, 10)}...`
                  : text
                : "-"}
            </span>

            {text && (
              <CopyOutlined
                style={{ cursor: "pointer", color: "#1677ff" }}
                onClick={() => navigator.clipboard.writeText(text)}
              />
            )}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Gene By",
      dataIndex: "GeneratedBy",
      key: "GeneratedBy",
      render: (text) => (
        <Tooltip title={text || "-"}>
          <div className="d-flex align-items-center gap-2">
            <span>
              {text
                ? text.length > 10
                  ? `${text.substring(0, 10)}...`
                  : text
                : "-"}
            </span>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Gene On",
      dataIndex: "GeneratedOn",
      key: "GeneratedOn",
      render: (text) => (
        <Tooltip title={text || "-"}>
          <div className="d-flex align-items-center gap-2">
            <span>
              {text
                ? text.length > 10
                  ? `${text.substring(0, 10)}...`
                  : text
                : "-"}
            </span>
          </div>
        </Tooltip>
      ),
    },
  ];

  const fetchLocationTypes = async (superId) => {
    if (!superId) return;
    try {
      setLocationLoading(true);
      const res = await fetch(
        `${API_BASE_URL}api/org/getlocations?SuperId=${superId}`
      );

      if (!res.ok) throw new Error("Failed to fetch ServiceTypes");
      const data = await res.json();

      if (data.status === true) {
        setLocationType(
          data?.ResultData?.map((item) => ({
            label: item?.Name,
            value: item?.Id,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching service types:", error);
    } finally {
      setLocationLoading(false);
    }
  };

  const fetchDevices = async (superId, id) => {
    if (!superId) return;

    try {
      setDeviceLoading(true);

      const res = await fetch(
        `${API_BASE_URL}api/device/getdevices?SuperId=${superId}&LocationId=${id} `
      );

      const data = await res.json();

      if (data?.status && Array.isArray(data?.ResultData)) {
        setDeviceData(data.ResultData);
      } else {
        setDeviceData([]);
        console.error("Invalid API response:", data);
      }
    } catch (error) {
      console.error("Fetch Devices Error:", error);
      setDeviceData([]);
    } finally {
      setDeviceLoading(false);
    }
  };

  const fetchLocationHistory = async (superId) => {
    setLocationHistoryLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}api/org/licensehistory?SuperId=${superId}`
      );

      if (!response.ok) {
        throw new Error("API request failed");
      }

      const data = await response.json();

      if (data?.status === true) {
        setLocationHistory(data?.ResultData || []);
      } else {
        console.log("Invalid API response:", data);
        setLocationHistory([]);
      }
    } catch (error) {
      console.error("Fetch Location History Error:", error);
      setLocationHistory([]);
    } finally {
      setLocationHistoryLoading(false);
    }
  };

  const generateLicense = async () => {
    try {
      setLoading(true);

      const payload = {
        SuperId: record?.SuperId,
        UserId: userData?.[0]?.UserId,
        LocationId: selectedLocation,
        DeviceId: selectedDevice,
      };

      const response = await fetch(`${API_BASE_URL}api/org/generatelicense`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to generate license");
      }

      const data = await response.json();

      if (data?.status === true) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "License generated successfully",
          confirmButtonText: "OK",
        });

        console.log("License Response:", data);

        fetchLocationHistory(record.SuperId);

        setSelectedLocation(null);
        setSelectedDevice(null);

      
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data?.message || "Failed to generate license",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Generate License Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (record?.SuperId) {
      fetchLocationHistory(record.SuperId);
      fetchLocationTypes(record.SuperId);
    }
  }, [record]);
  return (
    <div className="modal fade" id="generatelicence">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">
              {/* {isEdit ? "Edit" : "Add"} */}
              Generate Licence -{" "}
              <span style={{ color: "orange" }}>{record?.OrgName}</span>
            </h4>

            <button
              id="closeAddCompanyModal"
              type="button"
              className="btn-close custom-btn-close p-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setSelectedLocation(null);
                setSelectedDevice(null);

             
              }}
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="modal-body">
            {/* <Spin spinning={loading}> */}
            <div className="card border-0 shadow-sm mb-4">
              <div className="card-body">
                <form>
                  <div className="row align-items-end">
                    {/* Licence Type */}
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">
                          Loction
                          <span className="text-danger">*</span>
                        </label>

                        <Select
                          className="w-100"
                          style={{ width: 100, height: 38 }}
                          placeholder=" select Location "
                          options={locationType}
                          value={selectedLocation}
                          onChange={(value) => {
                            setSelectedLocation(value);

                            fetchDevices(record?.SuperId, value);
                          }}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          popupClassName=""
                          dropdownStyle={{ zIndex: 9999 }}
                          dropdownRender={(menu) => (
                            <div style={{ zIndex: 9999, position: "relative" }}>
                              {menu}
                            </div>
                          )}
                        />
                      </div>
                    </div>

                    {/* Device Type */}
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">
                          Device
                          <span className="text-danger">*</span>
                        </label>

                        <Select
                          className="w-100"
                          style={{ height: 38 }}
                          placeholder="Select Device"
                          value={selectedDevice}
                          loading={deviceLoading}
                          options={deviceData?.map((item) => ({
                            label: item?.DeviceName,
                            value: item?.Id,
                          }))}
                          onChange={(value) => setSelectedDevice(value)}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          popupClassName=""
                          dropdownStyle={{ zIndex: 9999 }}
                          dropdownRender={(menu) => (
                            <div style={{ zIndex: 9999, position: "relative" }}>
                              {menu}
                            </div>
                          )}
                        />
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="col-md-4">
                      <div className="mb-3 d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light me-2"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setSelectedLocation(null);
                            setSelectedDevice(null);

                            
                          }}
                        >
                          Cancel
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={generateLicense}
                          loading={loading}
                        >
                          Generate
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="card border-0 shadow-sm">
              <div className="card-header bg-light d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Licence List</h5>
              </div>

              <div className="card-body p-2">
                <Table
                  columns={columns}
                  dataSource={locationHistory}
                  loading={locationLoading}
                  rowKey={(record) => record.Id}
                  pagination={{ pageSize: 5 }}
                  scroll={{ x: true }}
                />
              </div>
            </div>
            {/* </Spin> */}
          </div>
        </div>
      </div>
    </div>
  );
};
GenerateLicence.propTypes = {
  record: PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    OrgName: PropTypes.string,
    SuperId: PropTypes.number,
  }),
};
export default GenerateLicence;
